import React, { useState } from 'react';
import AxiosClient from '../assets/AxiosClient';
import { useStateContext } from '../Contexts/ContextProvider';
import './AcceptRequest.css';

function AcceptRequest({ user, attend, handelClose }) {
  const [loading, setIsLoading] = useState(false);
  const { SetNotification } = useStateContext();
  const [additionalNote, setAdditionalNote] = useState('');

  const handleAccept = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = {
      id: attend,
      dates: ['2026-08-28'],
      report: additionalNote,
    };

    try {
      const response = await AxiosClient.post('/Registeration/Accepted', payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.status === 200) {
        SetNotification('Request has been accepted successfully', 'info');
        handelClose();
      }
    } catch (error) {
      console.error(error);
      SetNotification('Unable to accept this request right now.', 'danger');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay m-2 p-4">
      <div className="modal-card">
        <div className="modal-header">
          <div>
            <p className="modal-eyebrow">Review request</p>
            <h5 className="modal-title">Approve attendance</h5>
          </div>
          <button type="button" className="close-button" onClick={handelClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="modal-intro">
            <p className="modal-name">{user?.first_name} {user?.last_name}</p>
            <p className="modal-subtitle">Add a short note and confirm the scheduled attendance date.</p>
          </div>

          <div className="info-chip">
            <i className="material-icons" style={{ fontSize: '16px' }}>event_available</i>
            Friday, 28 August 2026
          </div>

          <textarea
            className="input-textarea"
            rows="4"
            placeholder="Write any special instructions or notes..."
            value={additionalNote}
            onChange={(e) => setAdditionalNote(e.target.value)}
          />
          <p className="helper-text">This note will be attached to the acceptance record.</p>

          <div className="modal-actions">
            <button type="button" className="cancel-button" onClick={handelClose}>
              Cancel
            </button>
            <button type="button" className="accept-button" onClick={handleAccept} disabled={loading}>
              {loading ? 'Processing...' : 'Accept request'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AcceptRequest;
